<template>
  <v-card>
    <v-card-title class="blue-grey darken-3 white--text">
      {{ number }}
      <v-spacer />
      <v-btn dark icon @click="$emit('close')" title="Закрыть"><v-icon>fas fa-times</v-icon></v-btn>
    </v-card-title>
    <a-loader v-if="loading" />
    <v-card-text class="whatsapp-chat" ref="chat_block">
      <div class="whatsapp-chat-row" v-for="(el, i) of data" :key="i">
        <div v-if="i == data.length - 1 || getDateString(el.createdon) !== getDateString(data[i + 1].createdon)" class="row-date">
          <div class="row-date-inner">{{ getDateString(el.createdon) }}</div>
        </div>
        <div v-if="testShowNewMess(el)" class="row-date">
          <div class="row-date-inner">Новое сообщение</div>
        </div>
        <div class="row-message" :class="el.sender_number == number ? 'left' : 'right'">
          <div class="row-message-inner">
            <div v-if="el.user_id" class="pink--text">{{ el.user_name }}</div>
            <div v-if="el.type == 'text' || el.type == 'template' || el.type == null">{{ el.message }}</div>
            <div v-else-if="el.type == 'image'">
              <a :href="el.media.url" target="blank"><img :src="el.media.url" style="max-width: 300px" /></a>
            </div>
            <div v-else-if="el.type == 'sticker'">
              <img :src="el.media.url" style="max-width: 300px" />
            </div>
            <div v-else-if="el.type == 'file' && el.media != null">
              <a :href="el.media.url" target="blank"><v-icon x-large>fas fa-file</v-icon></a>
              <div>{{ el.media.filename }}</div>
            </div>
            <div v-else-if="el.type == 'audio' && el.media != null">
              <audio controls>
                <source :src="el.media.url" :type="el.media.contentType" />
              </audio>
            </div>
            <div class="row-message-inner-date">
              {{ getTimeString(el.createdon) }}
              <span v-if="el.direction == 2">
                <i v-if="el.status == 1 || el.status == 2" class="fas fa-check"></i>
                <i v-else-if="el.status == 3" class="fas fa-check-double"></i>
                <i v-else-if="el.status == 4" class="green--text fas fa-check-double"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="whatsapp-input-wrapper pa-1 blue-grey darken-3 white--text" style="position: absolute; height: 58px; bottom: 0; width: 100%">
      <div class="d-flex" style="width: 100%">
        <div class="pt-3 ml-1 mx-2 wa-upload">
          <label for="wa-upload-file"><v-icon dark>fas fa-paperclip </v-icon> </label>
          <input type="file" name="wa-file" id="wa-upload-file" @change="onChangeFile" />
        </div>
        <div style="width: 100%">
          <input class="whatsapp-input" v-model="textMessage" placeholder="Введите сообщение" />
        </div>
        <div class="pa-1 ml-1">
          <v-btn dark icon @click="textMessage ? sendMessage(textMessage) : (showTemplateDialog = true)" title="Послать сообщение"
            ><v-icon>fas fa-paper-plane </v-icon></v-btn
          >
        </div>
      </div>
    </v-card-actions>
    <v-dialog :value="messageBlockDialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="red white--text">
          <v-spacer />
          ВНИМАНИЕ!!
          <v-spacer />
          <v-btn dark icon @click="messageBlockDialog = false" title="Закрыть"><v-icon>fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="py-4">
          <p>Для начала диалога необходимо отправить шаблонное сообщение и дождаться ответа от клиента</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="primary"
            @click="
              messageBlockDialog = false;
              showTemplateDialog = true;
            "
            >Отправить сообщение</v-btn
          >
          <v-btn @click="messageBlockDialog = false" title="Закрыть">Закрыть</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <templateDialog :number="number" v-model="showTemplateDialog" />
    <v-dialog v-model="uploadLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Пожалуста подождите
          <v-progress-linear :value="uploadStatus" color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  components: {
    templateDialog: () => import("./templateDialog.vue"),
  },
  props: {
    number: String,
    isAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      data: [],
      textMessage: "",
      pager: null,
      isTheEnd: null,
      showTemplateDialog: false,
      messageBlockDialog: false,
      canSendingMessages: false,
      uploadLoading: false,
      uploadStatus: 0,
    };
  },
  created() {
    this.$root.$on("websocket", this.registerWS);
  },
  mounted() {
    document.addEventListener("scroll", this.onScroll, true);
  },
  destoyed() {
    document.removeEventListener("scroll", this.onScroll, true);
    this.$root.$off("websocket", this.registerWS);
  },
  watch: {
    number: {
      handler() {
        this.uploadLoading = false;
        this.uploadStatus = 0;
        this.textMessage = "";
        this.data = [];
        this.showNewMess = false;
        this.pager = {
          page: 0,
          limit: 30,
        };
        this.isTheEnd = false;
        this.fetchData();
      },
      immediate: true,
    },
  },
  methods: {
    onChangeFile() {
      // this.testCanSendMessage();
      // if (!this.canSendingMessages) {
      //     this.messageBlockDialog = true;
      //     return;
      // }
      const file = document.getElementById("wa-upload-file").files[0];
      if (file) this.uploadFile(file);
    },
    uploadFile(file) {
      this.uploadLoading = true;
      this.uploadStatus = 0;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("name", file.name);
      this.$axios
        .post(this.$root.api.bUrl + "/file/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            this.status = parseInt((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((response) => {
          this.uploadLoading = false;
          let data = response.data.data;
          this.sendFile({
            url: this.$root.api.bUrl + "/file/download/" + data.file,
            filename: data.name,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    testShowNewMess(mess) {
      if (mess.status == 1 && !this.showNewMess) {
        this.showNewMess = true;
        return true;
      }
      return false;
    },
    onScroll() {
      if (this.$refs.chat_block) {
        let el = this.$refs.chat_block;

        let offset = 200;
        if (el.scrollHeight - el.offsetHeight <= -el.scrollTop + offset) {
          this.onScrollEnd();
        }
      }
    },
    onScrollEnd() {
      if (!this.isTheEnd && !this.loading) {
        this.pager.page++;
        this.fetchData();
      }
    },
    registerWS(data) {
      let regEvent = "whatsapp";
      // if (this.isAll) regEvent = "whatsapp_all"
      if (data && data.e == regEvent) {
        const r = data.r;
        if (r.direction == 1 && r.sender_number == this.number) {
          this.data.unshift(r);
        } else if (r.direction == 2 && r.recipient_number == this.number) {
          this.data.unshift(r);
        }
      } else if (data && data.e == "whatsapp-status") {
        for (const el of this.data) {
          if (el.id == data.r.id) {
            el.status = data.r.status;
          }
        }
      }
      this.testCanSendMessage();
      this.setViewed();
    },
    async sendMessage(message) {
      if (message) {
        this.testCanSendMessage();
        if (!this.canSendingMessages) {
          this.messageBlockDialog = true;
          return;
        }
        try {
          await this.$axios.post("/wa/messages", {
            type: "text",
            message: message,
            recipient_number: this.number,
          });
          this.textMessage = "";
        } catch (error) {
          console.error(error);
        }
      }
    },
    async sendTemplate(template_id = "48f704aa-cd70-4cea-bb9a-26abd270b94b", params = ["10"]) {
      let data = {
        type: "template",
        recipient_number: this.number,
        data: {
          template_id: template_id,
          params: params,
        },
      };
      try {
        await this.$axios.post("/wa/messages", data);
        this.textMessage = "";
      } catch (error) {
        console.error(error);
      }
    },
    async sendFile(fileData) {
      try {
        await this.$axios.post("/wa/messages", {
          data: "file",
          media: JSON.stringify(fileData),
          recipient_number: this.number,
        });
        this.textMessage = "";
      } catch (error) {
        console.error(error);
      }
    },
    getMedia(el) {
      try {
        if (el) return JSON.parse(el.media);
      } catch (error) {
        console.error(error);
      }
    },
    getDateString(d) {
      let a = new Date(d);
      return a.toLocaleDateString("ru");
    },
    getTimeString(d) {
      let a = new Date(d);
      return a.toLocaleTimeString("ru", { hour: "2-digit", minute: "2-digit" });
    },
    testCanSendMessage() {
      let a;
      for (const el of this.data) {
        if (el.sender_number == this.number) {
          a = el;
          break;
        }
      }
      if (a && new Date(a.createdon).getTime() + 1000 * 3600 * 24 >= Date.now()) {
        this.canSendingMessages = true;
      } else {
        this.canSendingMessages = false;
      }
    },
    async setViewed() {
      // if (this.isAll) return;
      try {
        let count = 0;
        for (const el of this.data) {
          if (el.viewed != 1) {
            await this.$axios.post("/wa/messages_view", {
              id: el.id,
              viewed: 1,
            });
            count++;
          }
        }
        this.$root.$emit("set_viewed_wa", { sender_number: this.number });
        // this.$root.$emit('update_income_wa', { wa_number: this.number, count: count});
      } catch (error) {
        console.error(error);
      }
    },
    async fetchData() {
      if (!this.number) return;
      try {
        this.loading = true;
        const response = await this.$axios.get("/wa/messages/" + this.number, {
          params: {
            pager: JSON.stringify(this.pager),
          },
        });
        if (this.pager.page > 0) {
          for (const el of response.data.data) {
            this.data.push(el);
          }
        } else {
          this.data = response.data.data;
          this.testCanSendMessage();
          // if (!this.canSendingMessages) this.messageBlockDialog = true;
        }
        this.setViewed();
        if (response.data.data.length < this.pager.limit) this.isTheEnd = true;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss">
.wa-upload {
  label {
    cursor: pointer;
  }

  input {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
}

.whatsapp-input-wrapper {
  // background: #aaa;
}

.whatsapp-input {
  background: #fff;
  border-radius: 6px;
  margin: 5px;
  padding: 8px 10px;
  width: 100%;
  outline: none;
  caret-color: auto;
}

.whatsapp-chat {
  position: absolute;
  overflow: auto;
  top: 62px;
  bottom: 58px;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  background: url(/img/bg-chat-tile-dark_a4be512e7195b6b733d9110b408f075d.png) repeat #eee;
}

.whatsapp-chat-row {
  .row-date {
    display: flex;
    justify-content: center;

    .row-date-inner {
      margin: 10px;
      padding: 5px 10px;
      background-color: #fff;
      box-shadow: 0px 1px 0 #e2e2e2;
      border-radius: 7.5px;
    }
  }

  .row-message {
    padding: 0;
    margin: 2px 10px 2px 10px;
    display: flex;

    &.left {
      justify-content: left;

      .row-message-inner {
        background-color: #fff;
      }
    }

    &.right {
      justify-content: right;

      .row-message-inner {
        background-color: #d9fdd3;
      }
    }

    .row-message-inner {
      box-shadow: 0px 1px 0 #e2e2e2;
      white-space: pre-line;
      max-width: 400px;
      border: 1px solid transparent;
      border-radius: 7.5px;
      padding: 8px 10px 2px 10px;
    }

    .row-message-inner-date {
      font-size: 12px;
      color: #aaa;
      margin-left: 30px;
      text-align: right;
    }
  }
}
</style>
